import {Dialog} from 'platform/components';
import {Box, Grid, GridItem, Heading, Text, VStack} from 'platform/foundation';

import {useEffect, useState} from 'react';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

// const HOW_IT_WORKS_URL = 'https://carvago.com';

interface SourcingCarvagoBuyDialogProps extends TestIdProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (message: string) => void;
}

export function SourcingCarvagoBuyDialog(props: SourcingCarvagoBuyDialogProps) {
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    if (!props.isOpen) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setMessage('');
    }
  }, [props.isOpen]);

  const handleConfirm = () => {
    props.onConfirm(message);
  };

  // const handleHowItWorks = () => openInNewTab(HOW_IT_WORKS_URL);

  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={i18n.t('page.sourcing.labels.carvagoBuyDialogTitle')}
      buttons={[
        {
          title: i18n.t('general.actions.cancel'),
          onClick: props.onClose,
          variant: 'secondary',
          'data-testid': suffixTestId('carvagoBuyDialog-cancel', props),
        },
        {
          title: i18n.t('general.actions.confirm'),
          onClick: handleConfirm,
          variant: 'primary',
          'data-testid': suffixTestId('carvagoBuyDialog-confirm', props),
        },
      ]}
      data-testid={suffixTestId('carvagoBuyDialog', props)}
    >
      <VStack spacing={4}>
        <Heading size={3}>{i18n.t('page.sourcing.labels.carvagoBuyDialogHeading')}</Heading>

        <Text size="base" color="secondary">
          {i18n.t('page.sourcing.labels.carvagoBuyDialogDescription')}
        </Text>

        <Box
          backgroundColor="palettes.neutral.20.100"
          borderColor="palettes.neutral.40.100"
          border="1px solid"
          borderRadius="small"
          padding={4}
        >
          <VStack spacing={4}>
            <Text size="base" alternative>
              {i18n.t('page.sourcing.labels.carvagoBuyDialogChooseServiceTitle')}
            </Text>

            <Grid columns={3} spacing={4}>
              <GridItem>
                <VStack spacing={1}>
                  <Text size="xSmall" color="tertiary">
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep', {count: 1})}
                  </Text>
                  <Text size="base" alternative>
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep1Title')}
                  </Text>
                  <Text size="xSmall" color="secondary">
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep1Description')}
                  </Text>
                </VStack>
              </GridItem>
              <GridItem>
                <VStack spacing={1}>
                  <Text size="xSmall" color="tertiary">
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep', {count: 2})}
                  </Text>
                  <Text size="base" alternative>
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep2Title')}
                  </Text>
                  <Text size="xSmall" color="secondary">
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep2Description')}
                  </Text>
                </VStack>
              </GridItem>
              <GridItem>
                <VStack spacing={1}>
                  <Text size="xSmall" color="tertiary">
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep', {count: 3})}
                  </Text>
                  <Text size="base" alternative>
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep3Title')}
                  </Text>
                  <Text size="xSmall" color="secondary">
                    {i18n.t('page.sourcing.labels.carvagoBuyDialogStep3Description')}
                  </Text>
                </VStack>
              </GridItem>
            </Grid>

            {/* <HStack justify="center">
              <Button
                variant="success"
                rightIcon="hardware/keyboard_arrow_right"
                title={i18n.t('page.sourcing.labels.carvagoBuyDialogSeeHowItWorks')}
                onClick={handleHowItWorks}
                data-testid={suffixTestId('carvagoBuyDialog-howItWorks', props)}
              />
            </HStack> */}
          </VStack>
        </Box>

        {/* <Textarea
          label={i18n.t('page.sourcing.labels.carvagoBuyDialogMessageLabel')}
          value={message}
          onChange={(value) => setMessage(value ?? '')}
          minRows={3}
          data-testid={suffixTestId('carvagoBuyDialog-message', props)}
        /> */}
      </VStack>
    </Dialog>
  );
}
